import React from "react";
import { Box, Paper, Typography, Button, useTheme } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSearchParams, useNavigate } from "react-router-dom";

export const PaymentFailedScreen = () => {
    const theme = useTheme();
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const orderId = params.get("orderId");
    const isDark = theme.palette.mode === "dark";

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: isDark ? "#121212" : "#ffffff",
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: "100%",
                    maxWidth: 450,
                    p: 4,
                    borderRadius: 4,
                    textAlign: "center",
                    backgroundColor: isDark ? theme.palette.background.paper : "#f5f5f5",
                }}
            >
                <CancelIcon
                    sx={{
                        fontSize: 90,
                        color: "error.main",
                        mb: 2,
                        animation: "pop 0.4s ease-out",
                    }}
                />

                <Typography variant="h4" fontWeight={600} gutterBottom>
                    Payment Failed
                </Typography>

                <Typography variant="body1" color="text.secondary" mb={3}>
                    Unfortunately, the payment could not be completed.
                    {orderId && (
                        <>
                            <br /> Order ID: <strong>{orderId}</strong>
                        </>
                    )}
                </Typography>

                <Button
                    fullWidth
                    sx={{
                        mb: 2,
                        py: 1.2,
                        fontWeight: 600,
                        borderRadius: 2,

                        // 🔥 Error button colors
                        backgroundColor: isDark ? "#e53935" : "#c62828",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: isDark ? "#d32f2f" : "#b71c1c",
                        },
                    }}
                    onClick={() => navigate("/payment-retry")}
                >
                    Try Again
                </Button>

                <Button
                    fullWidth
                    variant="outlined"
                    sx={{
                        py: 1.2,
                        fontWeight: 600,
                        borderRadius: 2,
                        borderColor: isDark ? "#bbb" : "#888",
                        color: isDark ? "#ccc" : "#555",
                        "&:hover": {
                            borderColor: isDark ? "#ddd" : "#555",
                            backgroundColor: isDark ? "rgba(255,255,255,0.04)" : "#eaeaea",
                        },
                    }}
                    onClick={() => navigate("/")}
                >
                    Go to Home
                </Button>
            </Paper>

            <style>{`
                @keyframes pop {
                    0% { transform: scale(0.5); opacity: 0.2; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </Box>
    );
};
